import { Globe } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { LANG_OPTIONS } from "@/i18n/strings";

export default function LangSwitcher() {
  const { lang, setLang } = useSite();
  return (
    <div className="flex items-center gap-1 border border-slate-300 bg-white p-0.5" data-testid="lang-switcher">
      <Globe size={14} className="mx-1 text-slate-500" />
      {LANG_OPTIONS.map(([code, short, full]) => (
        <button key={code} onClick={() => setLang(code)} title={full} data-testid={`lang-option-${code}`}
          className={`px-2 py-1 font-mono text-[11px] font-semibold transition-colors ${lang === code ? "bg-[#0F2B48] text-white" : "text-slate-600 hover:text-[#0F2B48]"}`}>
          {short}
        </button>
      ))}
    </div>
  );
}
